export const EMPTY_STATE_KEY = {
  GETTING_STARTED: "gettingStarted",
  NO_TEMPLATE: "noTemplate",
};

export const getEmptyStateTemplate = (t) => ({
  [EMPTY_STATE_KEY.GETTING_STARTED]: {
    title: t("emptyState.gettingStarted.title"),
    description: t("emptyState.gettingStarted.description"),
    imageUrl: "/img/get-started-with-optics.svg",
  },
  [EMPTY_STATE_KEY.NO_TEMPLATE]: {
    title: t("emptyState.noTemplate.title"),
    description: t("emptyState.noTemplate.description"),
    imageUrl: "/img/get-started-with-optics.svg",
  },
});
